import scenes from '../scenes'
import * as overlayStyle from 'constants/overlayStyles'
import * as customFieldTypes from 'constants/customFieldTypes'
import * as sidebarSceneType from 'constants/sidebarSceneType'
import * as stylePresetType from 'constants/stylePresetType'

const customFields = [
  {
    id: 'preload',
    location: { scene: scenes[1] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene1', 'logo' ],
      isSmall: true,
    },
    fields: [
      {
        id: 'background',
        type: customFieldTypes.IMAGE,
        name: 'Edit bg',
        paths: [[ 'scene1', 'background' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_poster',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_poster`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_poster`, presetType: stylePresetType.ZOOM },
          {
            title: 'Darken / Lighten:',
            className: `bo_poster`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
          {
            title: 'Add background around image:',
            className: `bo_poster`,
            presetType: stylePresetType.AROUND
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene1', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo`,
            presetType: stylePresetType.AROUND
          },
          { className: 'bo_splash__logo', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene1', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__title',
        stylePresets: [
          {
            title: 'Title position:',
            className: `bo_splash__title`,
            presetType: stylePresetType.POSITION
          },
          {
            title: 'Text color:',
            className: 'bo_splash__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_splash__title`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_splash__title', presetType: stylePresetType.HIDDEN },
        ]
      }
    ]
  },
  {
    id: 'intro',
    location: { scene: scenes[2] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene2', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene2', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_curtains__bg',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_curtains__bg`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene2', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-2',
        customStyle: '.bo_splash__logo-2 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-2`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-2`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-2`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-4`,
              `bo_splash__logo-5`,
              `bo_splash__logo-6`,
              `bo_splash__logo-7`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-2', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'callout1',
        type: customFieldTypes.TEXT,
        name: 'Edit Callout Line 1',
        paths: [[ 'scene2', 'text1' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_curtains__text1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_curtains__text--1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_curtains__text--1`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: 'bo_curtains__text--1', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'callout2',
        type: customFieldTypes.TEXT,
        name: 'Edit Callout Line 2',
        paths: [[ 'scene2', 'text2' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_curtains__text2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_curtains__text--2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_curtains__text--2`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: 'bo_curtains__text--2', presetType: stylePresetType.TEXT_SIZE }
        ]
      }
    ]
  },
  {
    id: 'videoScene',
    location: { scene: scenes[3] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene3', 'video', 'thumbUrl' ],
    },
    fields: [
      {
        id: 'video',
        type: customFieldTypes.VIDEO,
        name: 'Assign Video',
        paths: [[ 'scene3', 'video' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_video__video'
      },
      {
        id: 'background',
        type: customFieldTypes.BG,
        name: 'Background Color',
        paths: [[ 'scene3', 'background' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_video__content',
        stylePresets: [
          {
            title: 'Background Color:',
            className: 'bo_video__wrapper',
            presetType: stylePresetType.AROUND
          }
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene3', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-3',
        customStyle: '.bo_splash__logo-3 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-3`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-3`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-3`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-3`,
              `bo_splash__logo-2`,
              `bo_splash__logo-4`,
              `bo_splash__logo-5`,
              `bo_splash__logo-6`,
              `bo_splash__logo-7`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene3', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_video__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_video__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_video__title`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_video__title', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_video__title--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'desc',
        type: customFieldTypes.TEXT,
        name: 'Edit Description',
        paths: [[ 'scene3', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_video__description',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_video__description',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_video__description`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_video__description', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_video__description--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'button',
        type: customFieldTypes.TEXT,
        name: 'Edit Button',
        paths: [[ 'scene3', 'button' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_video__button',
        stylePresets: [
          {
            title: 'Text&Border color:',
            className: 'bo_video__button',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_video__button`, presetType: stylePresetType.TEXT_EFFECT },
        ]
      }
    ]
  },
  {
    id: 'slide1',
    location: { scene: scenes[4] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene4', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene4', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_slide__bg_1',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_slide__bg_1`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene4', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-4',
        customStyle: '.bo_splash__logo-4 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-4`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-4`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-4`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-4`,
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-5`,
              `bo_splash__logo-6`,
              `bo_splash__logo-7`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-4', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'subtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit Subtitle',
        paths: [[ 'scene4', 'subtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__subtitle_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__subtitle_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__subtitle_1`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__subtitle_1', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__subtitle_1--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene4', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__title_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__title_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__title_1`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__title_1', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__title_1--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene4', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__desc_1',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__desc_1',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__desc_1`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__desc_1', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__desc_1--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      }
    ]
  },
  {
    id: 'slide2',
    location: { scene: scenes[5] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene5', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene5', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_slide__bg_2',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_slide__bg_2`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene5', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-5',
        customStyle: '.bo_splash__logo-5 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-5`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-5`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-5`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-5`,
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-4`,
              `bo_splash__logo-6`,
              `bo_splash__logo-7`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-5', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'subtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit Subtitle',
        paths: [[ 'scene5', 'subtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__subtitle_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__subtitle_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__subtitle_2`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__subtitle_2', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__subtitle_2--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene5', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__title_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__title_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__title_2`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__title_2', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__title_2--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene5', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__desc_2',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__desc_2',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__desc_2`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__desc_2', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__desc_2--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
    ]
  },
  {
    id: 'slide3',
    location: { scene: scenes[6] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene6', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene6', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_slide__bg_3',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_slide__bg_3`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene6', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-6',
        customStyle: '.bo_splash__logo-6 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-6`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-6`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-6`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-6`,
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-4`,
              `bo_splash__logo-5`,
              `bo_splash__logo-7`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-6', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'subtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit Subtitle',
        paths: [[ 'scene6', 'subtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__subtitle_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__subtitle_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__subtitle_3`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__subtitle_3', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__subtitle_3--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene6', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__title_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__title_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__title_3`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__title_3', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__title_3--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene6', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__desc_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__desc_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__desc_3`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__desc_3', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__desc_3--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      }
    ]
  },
  {
    id: 'slide4',
    location: { scene: scenes[7] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene7', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene7', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_slide__bg_4',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_slide__bg_4`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene7', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-7',
        customStyle: '.bo_splash__logo-7 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-7`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-7`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-7`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-7`,
              `bo_splash__logo-6`,
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-4`,
              `bo_splash__logo-5`,
              `bo_splash__logo-8`
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-7', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'subtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit Subtitle',
        paths: [[ 'scene7', 'subtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__subtitle_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__subtitle_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__subtitle_4`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__subtitle_4', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__subtitle_4--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene7', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__title_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__title_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__title_4`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__title_4', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__title_4--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [[ 'scene7', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_slide__desc_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_slide__desc_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_slide__desc_4`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_slide__desc_4', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_slide__desc_4--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      }
    ]
  },
  {
    id: 'lastScene',
    location: { scene: scenes[8], shareButtonsVisible: 0 },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: [ 'scene8', 'bg' ],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [[ 'scene8', 'bg' ]],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'bo_last__bg',
        stylePresets: [
          {
            title: 'Darken / Lighten:',
            className: `bo_last__bg`,
            presetType: stylePresetType.DARKEN_LIGHTEN
          },
        ]
      },
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [[ 'scene8', 'logo' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_splash__logo-8',
        customStyle: '.bo_splash__logo-8 {\n}',
        stylePresets: [
          {
            title: 'Image position:',
            className: `bo_splash__logo-8`,
            presetType: stylePresetType.POSITION
          },
          { title: 'Image size:', className: `bo_splash__logo-8`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `bo_splash__logo-8`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `bo_splash__logo-8`,
              `bo_splash__logo-2`,
              `bo_splash__logo-3`,
              `bo_splash__logo-4`,
              `bo_splash__logo-5`,
              `bo_splash__logo-6`,
              `bo_splash__logo-7`,
            ],
            getSlideClassName: num => `bo_splash__logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
          { className: 'bo_splash__logo-8', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [[ 'scene8', 'title' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_last__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_last__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_last__title`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_last__title', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_last__title--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'desc',
        type: customFieldTypes.TEXT,
        name: 'Edit Description',
        paths: [[ 'scene8', 'description' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_last__description',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_last__description',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_last__description`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_last__description', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_last__description--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'button',
        type: customFieldTypes.ACTION_BUTTON_W_URL,
        name: 'Edit Button',
        paths: [[ 'scene8', 'button' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_last__button',
        related: {
          url: [ 'scene8', 'buttonUrl' ]
        }
      },
      {
        id: 'buttonUrl',
        type: customFieldTypes.TEXT,
        name: 'Edit Button URL',
        paths: [[ 'scene8', 'buttonUrl' ]],
      },
      {
        id: 'optionalBlock',
        type: customFieldTypes.OPTIONAL_BLOCK,
        name: 'Optional block type',
        paths: [[ 'scene8', 'optionalBlockType' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_last__optional-block',
      },
      {
        id: 'signUpButton',
        type: customFieldTypes.ACTION_BUTTON_W_EMAIL,
        name: 'Sign Up Button',
        paths: [[ 'scene8', 'signUpButton' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_last__signup--button',
        related: {
          email: [[ 'scene8', 'signUpEmail' ]],
          emailFieldNum: 0
        }
      },
      {
        id: 'shareButton',
        type: customFieldTypes.SHARE_BUTTON,
        name: 'Edit share button',
        paths: [[ 'lastScene', 'shareButton' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__main-button',
        stylePresets: [
          {
            className: 'bo_share__main-button', presetType: stylePresetType.HIDDEN
          }
        ]
      }
    ]
  },
  {
    id: 'lastSceneShare',
    location: { scene: scenes[8], shareButtonsVisible: 1 },
    siderbarPreview: { type: sidebarSceneType.HIDDEN },
    fields: [
      {
        id: 'shareTitle',
        type: customFieldTypes.TEXT,
        name: 'Edit share title',
        paths: [[ 'scene8', 'shareTitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__title',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_share__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_share__title`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_share__title', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_share__title--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'shareSubtitle',
        type: customFieldTypes.TEXT,
        name: 'Edit share subtitle',
        paths: [[ 'scene8', 'shareSubtitle' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__subtitle',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'bo_share__subtitle',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `bo_share__subtitle`, presetType: stylePresetType.TEXT_EFFECT },
          { className: 'bo_share__subtitle', presetType: stylePresetType.HIDDEN },
          { title: 'Text size:', className: 'bo_share__subtitle--text', presetType: stylePresetType.TEXT_SIZE }
        ]
      },
      {
        id: 'fb',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Facebook',
        paths: [[ 'scene8', 'facebook' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__button--facebook',
        stylePresets: [
          {
            className: 'bo_share__button--facebook',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'twitter',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Twitter',
        paths: [[ 'scene8', 'twitter' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__button--twitter',
        stylePresets: [
          {
            className: 'bo_share__button--twitter',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'email',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Email',
        paths: [[ 'scene8', 'email' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__button--email',
        stylePresets: [
          {
            className: 'bo_share__button--email',
            presetType: stylePresetType.HIDDEN
          }
        ]
      },
      {
        id: 'phone',
        type: customFieldTypes.EDIT_SOCIAL_URL,
        name: 'Edit Phone',
        paths: [[ 'scene8', 'phone' ]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'bo_share__button--sms',
        stylePresets: [
          {
            className: 'bo_share__button--sms',
            presetType: stylePresetType.HIDDEN
          }
        ]
      }
    ]
  }
]

export default customFields



// WEBPACK FOOTER //
// ./src/templates/bouncy/template/customFields.js